export const CONNECT_WS = 'CONNECT_WS';
export const DISCONNECT_WS = 'DISCONNECT_WS';
export const NEW_LISTENER_WS = 'NEW_LISTENER_WS';
